import { Link } from "react-router-dom"
import CollapseHeader from "../../../core/common/collapse-header/collapse-header"
import { all_routes } from "../../router/all_routes"
import Table from '../../../core/common/dataTable/index'
import useApi from "../../../core/customhook/useApi"
import { useState } from "react"
import dayjs from "dayjs"
import PredefinedDateRanges from "../../../core/common/datePicker"
import moment, { Moment } from "moment"
import Swal from "sweetalert2"
import { Modal } from "bootstrap";

const ATTENDANCE_TYPE_LIMITS: Record<string, { min: number; max: number }> = {
    P: { min: 9, max: 24 },
    SH: { min: 7, max: 9 },
    HP: { min: 4.5, max: 7 },
    A: { min: 0, max: 0 },
    WO: { min: 0, max: 0 },
    H: { min: 0, max: 0 },
};

function hhmmToDecimalHours(time: string): number {
    const [hoursStr, minutesStr] = time.split(':');
    const hours = parseInt(hoursStr, 10);
    const minutes = parseInt(minutesStr, 10);

    const decimal = hours + minutes / 60;

    // Truncate to 2 decimals (floor)
    return Math.floor(decimal * 100) / 100;
}

function decimalHoursToHHMM(decimalHours: number): string {
    const hours = Math.floor(decimalHours);

    // Truncate minutes to match 2-decimal truncation
    const minutes = Math.round((decimalHours - hours) * 60);


    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
}

const TimeLogDetails = () => {

    const [newFiles, setNewFiles] = useState<File[]>([]);
    const [modalData, setModalData] = useState<any>({});
    const [removedFiles, setRemovedFiles] = useState<string[]>([]);
    const [count, setCount] = useState(0)
    const [selectRow, setSelectedRow] = useState<any>()
    const [selectedDateRange, setSelectedDateRange] = useState<{
        from: string;
        to: string;
    }>({
        from: moment().startOf('month').format("YYYY-MM-DD"),
        to: moment().endOf('month').format("YYYY-MM-DD"),
    });

    const columns = [
        {
            title: "S No.",
            key: "sno",
            render: (_text: any, _record: any, index: number) => index + 1
        },
        {
            title: "Project Name",
            dataIndex: "project_name",
            // render: (text: string) => (
            //     <Link to={all_routes.employeedetails}>{text}</Link>
            // ),
            sorter: (a: any, b: any) => a.employee_id.localeCompare(b.employee_id),
        },
        {
            title: "Task Name",
            dataIndex: "task_name",
            sorter: (a: any, b: any) => a.employee_name.localeCompare(b.employee_name),
        },

        {
            title: "Date",
            dataIndex: "log_date",
            render: (text: string) => dayjs(text).format("D MMMM YYYY"), // e.g. 10 October 2025
            sorter: (a: any, b: any) =>
                dayjs(a.log_date).unix() - dayjs(b.log_date).unix(),
        },
        {
            title: "Log Hours",
            dataIndex: "log_hours",
            render: (text: number) => (
                <div>
                    {decimalHoursToHHMM(text)}
                </div>
            )
            // sorter: (a: any, b: any) =>
            //     new Date(a.self_regn_in_time).getTime() - new Date(b.self_regn_in_time).getTime(),
        },
        {
            title: "Notes",
            dataIndex: "notes",
            // sorter: (a: any, b: any) =>
            //     new Date(a.self_regn_out_time).getTime() - new Date(b.self_regn_out_time).getTime(),
        },
        // {
        //     title: "Other Logs",
        //     dataIndex: "other_logs",
        //     // sorter: (a: any, b: any) => a.self_regn_hours - b.self_regn_hours,
        // },
        {
            title: "Action",
            key: "actions",
            render: (_text: string, record: any) => (
                <div className="action-icon d-inline-flex gap-2">

                    {/* View */}
                    <button
                        type="button"
                        className="btn text-info p-0"
                        title="View"
                        data-bs-toggle="modal"
                        data-bs-target="#timeSheetModal1"
                        onClick={() => {
                            setModalData(record);
                            setSelectedRow(record);
                        }}
                    >
                        <i className="ti ti-eye" />
                    </button>

                    {/* Edit */}
                    <button
                        type="button"
                        className="btn text-success p-0"
                        data-bs-toggle="modal"
                        data-bs-target="#attendanceModal"
                        title="Edit"
                        onClick={() => {
                            setModalData(record);
                            setSelectedRow(record);
                            // open edit modal or toggle edit state
                        }}
                    >
                        <i className="ti ti-edit" />
                    </button>

                    {/* Delete */}
                    <button
                        type="button"
                        className="btn text-danger p-0"
                        title="Delete"
                        onClick={() => {
                            setSelectedRow(record);
                            HandleDelete(record)
                            // open delete confirmation modal
                        }}
                    >
                        <i className="ti ti-trash" />
                    </button>

                </div>
            ),
        }

    ];

    // api to get data !!
    const { data: timeLogData } = useApi('/api/fetch-timelog', {
        method: "POST",
        autoCall: true,
        payload: {
            startDate: selectedDateRange.from,
            endDate: selectedDateRange.to
        },
        dependencies: [selectedDateRange, count]
    })


    // delete api 
    const { callApi: deleteApi } = useApi(``, {
        method: "DELETE",
        autoCall: false
    });

    const HandleDelete = async (record: any) => {
        try {
            const result = await Swal.fire({
                title: "Are you sure?",
                text: "Do you want to delete this Time Logs?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonColor: "#28a745",
                cancelButtonColor: "#d33",
                confirmButtonText: "Delete",
                cancelButtonText: "Cancel",
            });

            //   // Proceed only if user confirms
            if (result.isConfirmed) {
                const response = await deleteApi(
                    undefined,
                    `/api/delete-timelog/${record.id}`
                );

                if (response.success) {
                    Swal.fire({
                        icon: "success",
                        title: "Deleted!",
                        text: response.message || "Time log deleted successfully"
                    });
                    setCount(count + 1)
                }
            }
        } catch (error) {
            Swal.fire({
                icon: "warning",  // Use warning, not success
                title: "Failed",
                text: "Failed to delete Time Logs.",
            });
        }
    }

    const handleNotesChange = (e: any) => {
        setModalData((prev: any) => ({ ...prev, notes: e.target.value }));
    };

    const handleAttachmentChange = (e: any) => {
        setModalData((prev: any) => ({ ...prev, attachment: e.target.files?.[0] || null }));
    };
    // api call for validating time log hours
    const {
        data: attendanceData,
        loading: attendanceLoading,
        error: attendanceErrro,
    } = useApi("/api/timelog-dayvalidate", {
        method: "POST",
        autoCall: true,
        payload: {
            fromDate: selectedDateRange.from,
            toDate: selectedDateRange.to,
        },
        dependencies: [selectedDateRange]
    });

    const { callApi: EditApi } = useApi(`/api/edit-timelog`, {
        method: "POST",
        autoCall: false
    });

    const SubmitUpdatedTimeLog = async () => {
        console.log(selectRow.id, "sjdfjfdh")
        try {

            const formData = new FormData()
            // const formData = {
            formData.append("log_id", selectRow.id)
            formData.append("log_date", modalData?.log_date)
            formData.append("log_hours", String(modalData?.log_hours))
            formData.append("notes", modalData?.notes)
            // };
            if (newFiles && newFiles.length > 0) {
                newFiles.forEach((file) => {
                    formData.append("files", file);
                });
            }
            console.log("Form Data", formData)

            // Append removed files (URLs of existing documents to delete)
            if (removedFiles && removedFiles.length > 0) {
                formData.append("removedFiles", JSON.stringify(removedFiles));
            }


            const response = await EditApi(formData);

            if (response?.success) {
                Swal.fire({
                    icon: "success",
                    title: "TimeLog Updated",
                    text: response?.message || "Time log updated successfully.",
                }).then(() => {
                    document.getElementById("closed_modal")?.click();
                    // setModalData({});
                    // setSelectedRow(null);
                    // setCount(prev => prev + 1);
                    setModalData({});
                    setSelectedRow(null);
                    setNewFiles([]);       // reset new files
                    setRemovedFiles([]);   // reset removed files
                    setCount(prev => prev + 1);
                });;
            } else {
                Swal.fire({
                    icon: "error",
                    title: "Failed to Update",
                    text: response?.message || "Something went wrong while updating the time log.",
                });
            }
        } catch (error) {
            console.error("Error while updating time log:", error);
            Swal.fire({
                icon: "error",
                title: "API Error",
                text: "An error occurred while processing your request.",
            });
        }
    };

    const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.files) {
            setNewFiles([...newFiles, ...Array.from(e.target.files)]);
        }
    };

    // Handle removing newly added files
    const handleRemoveNewFile = (index: number) => {
        const updatedFiles = [...newFiles];
        updatedFiles.splice(index, 1);
        setNewFiles(updatedFiles);
    };

    // Existing remove function for old documents
    // const handleRemoveDocument = (index: number) => {
    //     if (!modalData?.documents) return;

    //     const updatedLogs = modalData.documents;
    //     updatedLogs.splice(index, 1);
    //     setModalData({
    //         ...modalData,
    //         documents: updatedLogs,
    //     });
    // };

    const handleRemoveDocument = (index: number) => {
        if (!modalData?.documents) return;

        const fileToRemove = modalData.documents[index]; // URL of file to remove

        // Add to removedFiles state
        setRemovedFiles(prev => [...prev, fileToRemove]);

        // Update UI by removing from modalData.documents
        const updatedDocuments = modalData.documents.filter((_: any, i: any) => i !== index);
        setModalData({ ...modalData, documents: updatedDocuments });
    };



    return (
        <>
            <div className="page-wrapper">
                <div className="content">
                    {/* BreadCum */}
                    <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
                        <div className="my-auto mb-2">
                            <h2 className="mb-1">Time Logs Details</h2>
                            <nav>
                                <ol className="breadcrumb mb-0">
                                    <li className="breadcrumb-item">
                                        <Link to={all_routes.adminDashboard}>
                                            <i className="ti ti-smart-home" />
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item">Time-Sheet</li>
                                    <li className="breadcrumb-item">Time Logs Details</li>
                                </ol>
                            </nav>
                        </div>
                        <div className="ms-2 head-icons">
                            <CollapseHeader />
                        </div>
                    </div>
                    {/* BreadCumb */}
                    <div className="card">
                        <div className="card-header">
                            {/* <h5>Time Log Details</h5> */}
                            <div className="d-flex my-xl-auto right-content align-items-center justify-content-end flex-wrap row-gap-3">
                                <div className="me-3">
                                    <div className="input-icon-end position-relative">
                                        <PredefinedDateRanges
                                            onChange={(start: Moment, end: Moment) => {
                                                setSelectedDateRange({
                                                    from: start.format("YYYY-MM-DD"),
                                                    to: end.format("YYYY-MM-DD"),
                                                });
                                            }}
                                        />
                                        <span className="input-icon-addon">
                                            <i className="ti ti-chevron-down" />
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className="card-body"> */}
                        <div className="card-body p-0">
                            <Table dataSource={timeLogData?.data || []} columns={columns} Selection={false} showSearchInput={true} />
                        </div>
                        {/* </div> */}
                    </div>
                </div>
            </div>

            {/* Bootstrap Update Modal */}
            <div
                className="modal fade"
                id="attendanceModal"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                Update Time Log – {dayjs(modalData?.log_date).format("DD MMM YYYY")}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                                id="closed_modal"
                            />
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Enter Hours</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    value={decimalHoursToHHMM(modalData?.log_hours)}
                                    // onChange={handleHoursChange}
                                    readOnly
                                    disabled
                                />
                            </div>

                            {/* <div className="mb-3">
                                <label className="form-label">Existing Documents</label>

                                {modalData?.other_logs && JSON.parse(modalData.other_logs).length > 0 ? (
                                    <ul className="list-group">
                                        {JSON.parse(modalData.other_logs).map((file: any, index: number) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <span>Document {index + 1}</span>

                                                <a
                                                    href={file.filename}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-outline-primary"
                                                >
                                                    View
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-muted">No document uploaded</p>
                                )}
                            </div> */}
                            <div className="mb-3">
                                <label className="form-label">Existing Documents</label>

                                {modalData?.documents && modalData.documents.length > 0 ? (
                                    <ul className="list-group mb-2">
                                        {modalData.documents.map((file: any, index: number) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <span>Document {index + 1}</span>
                                                <div>
                                                    <a
                                                        href={file}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="btn btn-sm btn-outline-primary me-2"
                                                    >
                                                        View
                                                    </a>
                                                    <button
                                                        className="btn btn-sm btn-outline-danger"
                                                        onClick={() => handleRemoveDocument(index)}
                                                    >
                                                        Remove
                                                    </button>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-muted">No document uploaded</p>
                                )}

                                <label className="form-label mt-2">Upload New Documents</label>
                                <input
                                    type="file"
                                    className="form-control"
                                    multiple
                                    onChange={handleFileChange}
                                />

                                {newFiles.length > 0 && (
                                    <ul className="list-group mt-2">
                                        {newFiles.map((file, index) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <span>{file.name}</span>
                                                <button
                                                    className="btn btn-sm btn-outline-danger"
                                                    onClick={() => handleRemoveNewFile(index)}
                                                >
                                                    Remove
                                                </button>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </div>




                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    value={modalData?.notes}
                                    onChange={handleNotesChange}
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary mx-2"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                            <button
                                className="btn btn-primary"
                                onClick={SubmitUpdatedTimeLog}
                            >
                                Save
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Bootstrap Update Modal */}

            {/* Bootstrap View Modal */}
            <div
                className="modal fade"
                id="timeSheetModal1"
                tabIndex={-1}
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                View Time Log – {dayjs(modalData?.log_date).format("DD MMMM YYYY")}
                            </h5>
                            <button
                                type="button"
                                className="btn-close"
                                data-bs-dismiss="modal"
                            />
                        </div>

                        <div className="modal-body">
                            <div className="mb-3">
                                <label className="form-label">Enter Hours</label>
                                <input
                                    type="time"
                                    className="form-control"
                                    value={decimalHoursToHHMM(modalData?.log_hours)} // convert decimal to HH:MM
                                    readOnly
                                />
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Existing Documents</label>

                                {modalData?.documents && modalData.documents.length > 0 ? (
                                    <ul className="list-group">
                                        {modalData.documents.map((file: any, index: number) => (
                                            <li
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <span>Document {index + 1}</span>

                                                <a
                                                    href={file}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-outline-primary"
                                                >
                                                    View
                                                </a>
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p className="text-muted">No document uploaded</p>
                                )}
                            </div>

                            <div className="mb-3">
                                <label className="form-label">Description</label>
                                <textarea
                                    className="form-control"
                                    rows={3}
                                    value={modalData?.notes}
                                    readOnly
                                />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-secondary mx-2"
                                data-bs-dismiss="modal"
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            {/* Bootstrap View Modal */}
        </>
    )
}

export default TimeLogDetails;